import React from 'react';

interface Props {
  status: any;
}
export default class BulkUpsertActionExicCards extends React.Component<Props> {
  getStatusClass = (bulkAction: any): string =>
    bulkAction.isSuccess() ? 'green' : bulkAction.isFail() ? 'red' : 'gray';

  render() {
    const { status } = this.props;
    return (
      <table className="organization__table">
        <thead>
          <tr>
            <th className="organization__th">EXIC会員ID</th>
            <th className="organization__th">処理結果</th>
          </tr>
        </thead>
        <tbody>
          {status.actionExicCards.map((exic: any, i: number) => (
            <tr key={i} className="organization__tr">
              <td>{exic.exicNumber}</td>
              <td>{exic.statusMessage()}</td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
}
